<template>
  <div class="switcher">
    <input id="switcher_tax" v-model="showPricesWithTax" class="switcher__input" type="checkbox">
    <label :title="title" class="switcher__label" for="switcher_tax">{{ label }}</label>
  </div>
</template>

<script>
export default {
  props:    [
    'title',
    'label'
  ],
  computed: {
    showPricesWithTax: {
      get() {
        return this.$store.getters.showPricesWithTax
      },
      set(value) {
        this.$store.commit('SET_SHOW_PRICES_WITH_TAX', value)
      },
    },
  },
};
</script>
